module.exports = __webpack_public_path__ + "static/img/徕卡Q3 43.555a9ff6.png";